// ++++++++++ ---------- IMPORTS ---------- ++++++++++ */
const settings = window.getEmbedSettings();

const isPubPortalPreview = !!settings.embed.isPubPortalPreview;
const mxQuestionData = (isPubPortalPreview && typeof window.getMxQuestionData !== "undefined") ? window.getMxQuestionData() : [];
const mxResultData = (isPubPortalPreview && typeof window.getMxResultData !== 'undefined') ? window.getMxResultData() : {};
const pqQuestionData = (isPubPortalPreview && typeof window.getPqQuestionData !== "undefined") ? window.getPqQuestionData() : {};
const udcData = (isPubPortalPreview && typeof window.getUDCData !== "undefined") ? window.getUDCData() : {};

// ++++++++++ ---------- EXPORTS ---------- ++++++++++ */
export { settings, mxQuestionData, mxResultData, pqQuestionData, udcData };
// using this settings file as a proxy entry point to our real settings files ...
// the reason for this is we will probably be hardcoding multiple partner embeds ...
// and this gives us a simple way to change which settings we want to see quickly across the entire application
